import React, { createContext, useState } from "react";
import {SuperOrder} from "@beeldit/ecommerce/super-orders/models/SuperOrder";

interface EditObservationsActionContextType {
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;    
  element: SuperOrder;
  setElement: (element: any) => void;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
}

export const EditObservationsActionContext = createContext<EditObservationsActionContextType>({
  backendFormErrors: {},
  setBackendFormErrors: () => {},  
  element: new SuperOrder(),
  setElement: () => {},
  showModal: false,
  setShowModal: () => {},

});

interface EditObservationsActionProviderProps {
  children: React.ReactNode;
}

export const EditObservationsActionProvider: React.FC<EditObservationsActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [element, setElement] = useState<SuperOrder>(new SuperOrder());
  const [showModal, setShowModal] = useState(false);

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    element,
    setElement,
    showModal,
    setShowModal,
  };
  return (
    <EditObservationsActionContext.Provider value={value}>
      {children}
    </EditObservationsActionContext.Provider>
  );
};
